import { createContext } from 'react';

export interface SectionSaver {
  id: string;
  save: () => Promise<void>;
  isDirty: () => boolean;
}

export interface SpaceSettingsSaveContextValue {
  register: (saver: SectionSaver) => void;
  unregister: (id: string) => void;
  setSectionDirty: (id: string, dirty: boolean) => void;
}

const SpaceSettingsSaveContext =
  createContext<SpaceSettingsSaveContextValue | null>(null);

export default SpaceSettingsSaveContext;
